import { transcripts } from "./transcripts";

export const forwardTranslations = {
  en: {
    ...transcripts,
    "flm.forward#title": "FORWARD",
    "flm.forward#backToList": "Back to Videos",
    "flm.forward#searchPlaceholder": "Search videos...",
    "flm.forward.video1#title": "Session 1",
    "flm.forward.video2#title": "Session 2",
    "flm.forward.video3#title": "Session 3",
    "flm.forward.video4#title": "Session 4",
    "flm.forward.video5#title": "Session 5",
    "flm.forward.video6#title": "Session 6",
    "flm.forward.video7#title": "Session 7",
    "flm.forward.video8#title": "Session 8",
    "flm.forward.video9#title": "Session 9",
    "flm.forward.video10#title": "Session 10",
    "flm.forward.video11#title": "Session 11",
    "flm.forward.video12#title": "Session 12",
    "flm.forward.video13#title": "Session 13",
    "flm.forward.video14#title": "Session 14",
    "flm.forward.video15#title": "Session 15",
    "flm.forward.video16#title": "Session 16",
    "flm.forward.video17#title": "Session 17",
    "flm.forward.video18#title": "Session 18",
    "flm.forward.video19#title": "Session 19",
    "flm.forward.video20#title": "Session 20",
    "flm.forward.video1#description": `Sample video 1 description that explains what this video is about.`,
    "flm.forward.video2#description": `Sample video 2 description that explains what this video is about.`,
    "flm.forward.video3#description": `Sample video 3 description that explains what this video is about.`,
    "flm.forward.video4#description": `Sample video 4 description that explains what this video is about.`,
    "flm.forward.video5#description": `Sample video 5 description that explains what this video is about.`,
    "flm.forward.video6#description": `Sample video 6 description that explains what this video is about.`,
    "flm.forward.video7#description": `Sample video 7 description that explains what this video is about.`,
    "flm.forward.video8#description": `Sample video 8 description that explains what this video is about.`,
    "flm.forward.video9#description": `Sample video 9 description that explains what this video is about.`,
    "flm.forward.video10#description": `Sample video 1 description that explains what this video is about.`,
    "flm.forward.video11#description": `Sample video 1 description that explains what this video is about.`,
    "flm.forward.video12#description": `Sample video 1 description that explains what this video is about.`,
    "flm.forward.video13#description": `Sample video 1 description that explains what this video is about.`,
    "flm.forward.video14#description": `Sample video 1 description that explains what this video is about.`,
    "flm.forward.video15#description": `Sample video 1 description that explains what this video is about.`,
    "flm.forward.video16#description": `Sample video 1 description that explains what this video is about.`,
    "flm.forward.video17#description": `Sample video 1 description that explains what this video is about.`,
    "flm.forward.video18#description": `Sample video 1 description that explains what this video is about.`,
    "flm.forward.video19#description": `Sample video 1 description that explains what this video is about.`,
    "flm.forward.video20#description": `Sample video 2 description that explains what this video is about.`,
  },
  es: {
    "flm.forward#title": "FORWARD",
    "flm.forward#backToList": "Volver a Videos",
    "flm.forward#description": `Sample video description that explains what this video is about.`,
    "flm.forward#searchPlaceholder": "Buscar videos...",
    "flm.forward.video1#title": "Sesión 1",
    "flm.forward.video2#title": "Sesión 2",
    "flm.forward.video3#title": "Sesión 3",
    "flm.forward.video4#title": "Sesión 4",
    "flm.forward.video5#title": "Sesión 5",
    "flm.forward.video6#title": "Sesión 6",
    "flm.forward.video7#title": "Sesión 7",
    "flm.forward.video8#title": "Sesión 8",
    "flm.forward.video9#title": "Sesión 9",
    "flm.forward.video10#title": "Sesión 10",
    "flm.forward.video11#title": "Sesión 11",
    "flm.forward.video12#title": "Sesión 12",
    "flm.forward.video13#title": "Sesión 13",
    "flm.forward.video14#title": "Sesión 14",
    "flm.forward.video15#title": "Sesión 15",
    "flm.forward.video16#title": "Sesión 16",
    "flm.forward.video17#title": "Sesión 17",
    "flm.forward.video18#title": "Sesión 18",
    "flm.forward.video19#title": "Sesión 19",
    "flm.forward.video20#title": "Sesión 20",
    "flm.forward.video1#description": `Descripción de video 1 de muestra que explica lo que trata este video.`,
    "flm.forward.video2#description": `Descripción de video 2 de muestra que explica lo que trata este video.`,
    "flm.forward.video3#description": `Descripción de video 3 de muestra que explica lo que trata este video.`,
    "flm.forward.video4#description": `Descripción de video 4 de muestra que explica lo que trata este video.`,
    "flm.forward.video5#description": `Descripción de video 5 de muestra que explica lo que trata este video.`,
    "flm.forward.video6#description": `Descripción de video 6 de muestra que explica lo que trata este video.`,
    "flm.forward.video7#description": `Descripción de video 7 de muestra que explica lo que trata este video.`,
    "flm.forward.video8#description": `Descripción de video 8 de muestra que explica lo que trata este video.`,
    "flm.forward.video9#description": `Descripción de video 9 de muestra que explica lo que trata este video.`,
    "flm.forward.video10#description": `Descripción de video 1 de muestra que explica lo que trata este video.`,
    "flm.forward.video11#description": `Descripción de video 1 de muestra que explica lo que trata este video.`,
    "flm.forward.video12#description": `Descripción de video 1 de muestra que explica lo que trata este video.`,
    "flm.forward.video13#description": `Descripción de video 1 de muestra que explica lo que trata este video.`,
    "flm.forward.video14#description": `Descripción de video 1 de muestra que explica lo que trata este video.`,
    "flm.forward.video15#description": `Descripción de video 1 de muestra que explica lo que trata este video.`,
    "flm.forward.video16#description": `Descripción de video 1 de muestra que explica lo que trata este video.`,
    "flm.forward.video17#description": `Descripción de video 1 de muestra que explica lo que trata este video.`,
    "flm.forward.video18#description": `Descripción de video 1 de muestra que explica lo que trata este video.`,
    "flm.forward.video19#description": `Descripción de video 1 de muestra que explica lo que trata este video.`,
    "flm.forward.video20#description": `Descripción de video 2 de muestra que explica lo que trata este video.`,
  },
};
